import React, { useState } from 'react';
import { Grid } from '@mui/material';
import CustomForm from '../../components/form/form';
import { Main } from '../../constant';
import { useDispatch, useSelector } from 'react-redux';

const ClassSelect = (props) => {
  const [data, setData] = useState(Main().subject);
  const [teacherName, setTeacherName] = useState(props?.Name);
  const dispatch = useDispatch();
  const url = useSelector((state) => state.Api.ShowSubject);

  const ChangeOnSelect = (getparam) => {
    const teacherDetails = {
      classID: getparam[0],
      className: getparam[1],
      teacherRoll: props?.RollNum,
    };

    console.log('Selected Teacher Details:', teacherDetails);

    // Send data to parent
    if (props.settingClassTeacher) {
      props.settingClassTeacher(teacherDetails);
    }
  };

  return (
    <form>
      <Grid container mt={6}>
        <h2>{teacherName}</h2>
        <CustomForm
          data={data.inputs}
          ChangeOnSelect={ChangeOnSelect}
        />
      </Grid>
    </form>
  );
};

export default ClassSelect;
